<app-health-bar [health]="healthNum" [healthPercent]="healthPercent" [severity]="severity"
                [warningTooltipText]="warningTooltipText"></app-health-bar>
